export default __webpack_public_path__ + "static/media/create-landing-page.797fc4ec.svg";